function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (!customElements.get("cart-b2b-attributes")) {
  customElements.define(
    "cart-b2b-attributes",
    class CartB2b extends HTMLElement {
      constructor() {
        super();
        this.inputs = this.querySelectorAll("input");
        this.inputs?.forEach((input) => {
          this.saveAttributes(input.id, input.value);
          input.addEventListener(
            "change",
            debounce((event) => {
              this.saveAttributes(event.target.id, event.target.value);
            }, 300)
          );
        });
      }

      saveAttributes(id, value) {
        let inputId = id;
        if (id == "VatId") {
          inputId = "dic";
        }
        if (id == "ic") {
          inputId = "ico";
        }
        if (inputId == "ico" || inputId == "dic" || inputId == "firma") {
          const body = JSON.stringify({
            attributes: { [inputId]: value },
          });
          fetch("/cart/update", {
            ...fetchConfig(),
            ...{ body },
          });
        }
      }
    }
  );
}
